import { InternalThemeConfig } from "../../config";
import hexToRGBA from "../../../hexToRGBA";

const outlined = ({ palette, spacing }: InternalThemeConfig) => ({
	outlined: {
		color: undefined,
		backgroundColor: undefined,
		boxShadow: undefined,
		padding: "2rem 3.1rem 1.8rem 3.1rem",
		border: undefined,
		"&:disabled": {
			border: undefined,
		},
		"&.MuiButton-outlinedSizeSmall": {
			padding: `${spacing(1.375)} ${spacing(2.875)}`,
		},
	},
	outlinedPrimary: {
		color: palette.primary,
		border: `0.1rem solid ${palette.primary}`,
		background: palette.transparent,
		"&:hover": {
			border: undefined,
			backgroundColor: hexToRGBA(palette.primary, 0.12),
			borderColor: palette.lightPrimary,
		},
		"&:active": {
			backgroundColor: hexToRGBA(palette.primary, 0.12),
			borderColor: palette.lightPrimary,
		},
		"&:disabled": {
			borderColor: palette.grey40,
			color: palette.grey30,
			background: "none",
		},
	},
	outlinedSizeSmall: {},
	outlinedSecondary: {
		color: "#fff",
		border: `0.1rem solid ${palette.primary}`,
		background: palette.transparent,
		"&:hover": {
			backgroundColor: hexToRGBA(palette.primary, 0.12),
			borderColor: palette.primary,
		},
		"&:active": {
			backgroundColor: hexToRGBA(palette.primary, 0.12),
			borderColor: palette.primary,
		},
		"&:disabled": {
			borderColor: hexToRGBA(palette.grey30, 0.35),
			color: palette.grey30,
			background: "none",
		},
	},
});

export default outlined;
